import type { LanguagePack } from './types'

export const ta: LanguagePack = {
  navSaved: 'சேமித்தவை',
  navInfo: 'தகவல்',
  homeTitle: 'உங்கள் காகிதத்தை போட்டோ எடுங்கள்',
  homeHint: 'அதில் என்ன எழுதியிருக்கிறது, அடுத்து நீங்கள் என்ன செய்ய வேண்டும் என்று சம்ஜோ சொல்லும்.',
  takePhoto: 'போட்டோ எடுங்கள்',
  uploadFile: 'போட்டோ அல்லது PDF அப்லோட் செய்யுங்கள்',
  supportedFiles: 'போட்டோ (JPG, PNG, WEBP) அல்லது PDF · 10 MB வரை',
  chooseLanguage: 'எந்த மொழியில் விளக்க வேண்டும்',
  privacyLine: 'உங்கள் காகிதம் இந்த போனிலேயே படிக்கப்படுகிறது. நீங்கள் "சேமியுங்கள்" என்பதை அழுத்தினால் மட்டுமே இது சேமிக்கப்படும்.',

  previewTitle: 'போட்டோ சரியாக இருக்கிறதா?',
  rotate: 'திருப்புங்கள்',
  crop: 'ஓரத்தை வெட்டுங்கள்',
  cropDone: 'முடிந்தது',
  retake: 'மீண்டும் எடுங்கள்',
  readNow: 'படியுங்கள்',
  docLanguageLabel: 'காகிதம் எந்த மொழியில் எழுதப்பட்டுள்ளது?',
  docLanguageHint: 'ஆங்கிலமும் எப்போதும் சேர்த்துப் படிக்கப்படும்.',

  stepCheck: 'போட்டோ சரிபார்க்கப்படுகிறது…',
  stepRead: 'காகிதம் படிக்கப்படுகிறது…',
  stepExtract: 'முக்கியமான விவரங்கள் தேடப்படுகின்றன…',
  stepExplain: 'தமிழில் விளக்கப்படுகிறது…',
  firstTimeNote: 'முதல் முறை படிக்கும் டூல் டவுன்லோட் ஆவதால், கொஞ்சம் அதிக நேரம் ஆகும்.',
  cancel: 'ரத்து செய்யுங்கள்',

  errBadImage: 'போட்டோ கொஞ்சம் தெளிவாக இல்லை. இன்னொரு தெளிவான போட்டோ எடுங்கள்.',
  errNoText: 'இந்தக் காகிதத்தில் எழுத்து எதுவும் சம்ஜோவுக்குக் கிடைக்கவில்லை.',
  errUnclearPart: 'இந்தப் பகுதியை சம்ஜோவால் சரியாகப் படிக்க முடியவில்லை.',
  errUnsupportedLanguage: 'இந்த மொழிக்கு இன்னும் வசதி இல்லை.',
  errLongDocument: 'இந்தக் காகிதம் நீளமாக உள்ளது. முதலில் முக்கியமான பக்கங்களைத் தேர்ந்தெடுங்கள்.',
  errFileType: 'ஒரு போட்டோ (JPG, PNG, WEBP) அல்லது PDF தேர்ந்தெடுங்கள்.',
  errFileSize: 'இந்த ஃபைல் 10 MB-க்கு மேல் உள்ளது. சிறிய ஃபைலைத் தேர்ந்தெடுங்கள்.',
  errGeneric: 'ஏதோ தவறு நடந்துவிட்டது. மீண்டும் முயற்சி செய்யுங்கள்.',
  errOcrDownload: 'படிக்கும் டூல் டவுன்லோட் ஆகவில்லை. ஒருமுறை இன்டர்நெட்டை ஆன் செய்து மீண்டும் முயற்சி செய்யுங்கள்.',
  warnDark: 'போட்டோ இருட்டாக உள்ளது. நல்ல வெளிச்சத்தில் எடுத்த போட்டோ நன்றாகப் படிக்கப்படும்.',
  warnBlurry: 'போட்டோ மங்கலாக உள்ளது. போனை அசையாமல் பிடித்து மீண்டும் எடுங்கள்.',
  warnSmall: 'போட்டோ மிகவும் சிறியதாக உள்ளது. காகிதத்துக்கு அருகில் வைத்து எடுங்கள்.',
  tryAgain: 'மீண்டும் முயற்சி செய்யுங்கள்',

  pickPagesHint: (max) => `${max} பக்கங்கள் வரை தேர்ந்தெடுங்கள்.`,
  pageLabel: (n) => `பக்கம் ${n}`,
  readSelectedPages: (n) => (n === 1 ? '1 பக்கம் படியுங்கள்' : `${n} பக்கங்கள் படியுங்கள்`),

  typeSure: (name) => `இது ${name} போலத் தெரிகிறது.`,
  typeMaybe: (name) => `இது ${name} ஆக இருக்கலாம். ஆனால் சம்ஜோவுக்கு முழுமையாக உறுதியாகத் தெரியவில்லை.`,
  typeUnknown: 'இது எந்த வகைக் காகிதம் என்று சம்ஜோவுக்கு முழுமையாக உறுதியாகத் தெரியவில்லை.',
  docTypes: {
    income_certificate: { name: 'வருமானச் சான்றிதழ்', about: 'அரசுப் பதிவுகளின்படி ஒருவரின் அல்லது குடும்பத்தின் வருமானம் இதில் எழுதப்பட்டிருக்கும்.' },
    caste_certificate: { name: 'சாதிச் சான்றிதழ்', about: 'ஒருவர் எந்த சாதி அல்லது பிரிவைச் சேர்ந்தவர் என்று இதில் எழுதப்பட்டிருக்கும்.' },
    domicile_certificate: { name: 'இருப்பிடச் சான்றிதழ்', about: 'ஒருவர் நிரந்தரமாக எங்கே வசிக்கிறார் என்று இதில் எழுதப்பட்டிருக்கும்.' },
    birth_certificate: { name: 'பிறப்புச் சான்றிதழ்', about: 'இது பிறப்புக்கான அரசுப் பதிவு.' },
    death_certificate: { name: 'இறப்புச் சான்றிதழ்', about: 'இது இறப்புக்கான அரசுப் பதிவு.' },
    electricity_bill: { name: 'கரண்ட் பில் (மின்சார பில்)', about: 'பயன்படுத்திய மின்சாரமும், கட்ட வேண்டிய பணமும் இதில் இருக்கும்.' },
    water_bill: { name: 'தண்ணீர் பில்', about: 'கட்ட வேண்டிய தண்ணீர்க் கட்டணம் இதில் இருக்கும்.' },
    ration_card: { name: 'ரேஷன் கார்டு அல்லது ரேஷன் அறிவிப்பு', about: 'இது அரசு ரேஷன் கடையில் ரேஷன் வாங்குவது பற்றியது.' },
    aadhaar: { name: 'ஆதார் தொடர்பான காகிதம்', about: 'இது ஆதார் எண் அல்லது ஆதார் விவரங்கள் பற்றியது.' },
    pan_card: { name: 'பான் தொடர்பான காகிதம்', about: 'இது பான் (வரி அடையாள) எண் பற்றியது.' },
    bank_notice: { name: 'வங்கிக் கடிதம்', about: 'இது வங்கியிலிருந்து வந்த கடிதம் அல்லது அறிவிப்பு.' },
    loan_notice: { name: 'கடன் (லோன்) அறிவிப்பு', about: 'இது ஒரு கடன் அல்லது கட்ட வேண்டிய பாக்கிப் பணம் பற்றியது.' },
    income_tax_notice: { name: 'வருமான வரி நோட்டீஸ்', about: 'இது வருமான வரித் துறையிலிருந்து வந்தது.' },
    pension: { name: 'பென்ஷன் கடிதம்', about: 'இது பென்ஷன் பற்றியது.' },
    court_notice: { name: 'கோர்ட் அல்லது சட்ட நோட்டீஸ்', about: 'இது கோர்ட்டிலிருந்து வந்தது, அல்லது ஒரு சட்ட விஷயம் பற்றியது. இதை அலட்சியம் செய்யாதீர்கள்.' },
    land_record: { name: 'நிலப் பதிவு', about: 'இது நிலம் யாருடையது என்பது பற்றியது, அல்லது நில விவரங்கள் பற்றியது.' },
    property_tax: { name: 'சொத்து வரி (வீட்டு வரி) பில்', about: 'இது வீடு அல்லது சொத்துக்கான வரி பற்றியது.' },
    scholarship: { name: 'உதவித்தொகை (ஸ்காலர்ஷிப்) கடிதம்', about: 'இது படிப்புக்கான உதவித்தொகை பற்றியது.' },
    farmer_scheme: { name: 'விவசாயத் திட்டக் கடிதம்', about: 'இது விவசாயிகளுக்கான ஒரு திட்டம் அல்லது உதவி பற்றியது.' },
    school_letter: { name: 'பள்ளிக் கடிதம்', about: 'இது பள்ளியிலிருந்து வந்தது, அல்லது படிப்பு பற்றியது.' },
    marksheet: { name: 'மார்க் ஷீட் அல்லது ரிசல்ட்', about: 'இதில் தேர்வு மதிப்பெண்கள் அல்லது ரிசல்ட் இருக்கும்.' },
    insurance: { name: 'இன்சூரன்ஸ் (காப்பீடு) காகிதம்', about: 'இது ஒரு இன்சூரன்ஸ் பாலிசி பற்றியது.' },
    traffic_challan: { name: 'டிராஃபிக் அபராதச் சீட்டு (சலான்)', about: 'இது டிராஃபிக் அல்லது வாகன விதி தொடர்பான அபராதம்.' },
    job_notice: { name: 'வேலை அல்லது தேர்வு அறிவிப்பு', about: 'இது அரசு வேலை, ஆட்சேர்ப்பு அல்லது அதற்கான தேர்வு பற்றியது.' },
    application_receipt: { name: 'விண்ணப்ப ரசீது', about: 'விண்ணப்பம் பெறப்பட்டது என்பதை இது காட்டுகிறது.' },
    application_decision: { name: 'விண்ணப்பம் பற்றிய கடிதம்', about: 'இதில் ஒரு விண்ணப்பம் பற்றிய முடிவு அல்லது தகவல் இருக்கும்.' },
    government_notice: { name: 'அரசு அறிவிப்பு', about: 'இது ஒரு அரசு அலுவலகத்திலிருந்து வந்த அறிவிப்பு அல்லது உத்தரவு.' },
    lab_report: { name: 'மருத்துவப் பரிசோதனை அறிக்கை', about: 'இதில் இரத்தம் அல்லது பிற மருத்துவப் பரிசோதனைகளின் முடிவுகள் உள்ளன.' },
    rental_agreement: { name: 'வாடகை ஒப்பந்தம்', about: 'இது வீட்டு உரிமையாளருக்கும் குடியிருப்பவருக்கும் இடையிலான ஒப்பந்தம்.' },
    loan_agreement: { name: 'கடன் ஒப்பந்தம்', about: 'இதில் கடனின் விதிமுறைகள் உள்ளன: வட்டி, EMI மற்றும் கட்டணங்கள்.' },
    contract: { name: 'ஒரு ஒப்பந்தம்', about: 'இது இரு தரப்பினரும் பின்பற்ற வேண்டிய விதிமுறைகள் கொண்ட ஒப்பந்தம்.' },
    unknown: { name: 'காகிதம்', about: '' }
  },

  seedhiBaat: 'எளிமையாகச் சொன்னால்',
  docSays: 'காகிதத்தில் இருப்பது',
  samjhoSays: 'சம்ஜோ விளக்கம்',
  unclearText: 'இந்தப் பகுதி தெளிவாக இல்லை — அசல் காகிதத்தைப் பாருங்கள்.',

  aboutPerson: (name) => `இந்தக் காகிதம் இவரைப் பற்றியது: ${name}.`,
  issuedBy: (authority) => `இது இங்கிருந்து வந்தது: ${authority}.`,
  status: {
    approved: 'விண்ணப்பம் ஏற்றுக்கொள்ளப்பட்டது.',
    rejected: 'விண்ணப்பம் நிராகரிக்கப்பட்டது (ரிஜெக்ட் ஆனது).',
    pending: 'விண்ணப்பம் இன்னும் முடியவில்லை. இன்னும் முடிவு வரவில்லை.',
    cancelled: 'இது ரத்து செய்யப்பட்டது.'
  },
  dateSentence: {
    deadline: (d) => `கடைசி தேதி: ${d}.`,
    due: (d) => `பணம் கட்ட கடைசி தேதி: ${d}.`,
    hearing: (d) => `நேரில் வருவதற்குக் காகிதத்தில் கொடுத்துள்ள தேதி: ${d}.`,
    issue: (d) => `இது ${d} அன்று வழங்கப்பட்டது.`,
    validity: (d) => `இது ${d} வரை செல்லும்.`,
    birth: (d) => `எழுதியுள்ள பிறந்த தேதி: ${d}.`,
    other: (d) => `ஒரு தேதி எழுதப்பட்டுள்ளது: ${d}.`
  },
  daysLeft: (days) => (days === 1 ? 'இன்னும் 1 நாள் உள்ளது.' : `இன்னும் ${days} நாட்கள் உள்ளன.`),
  dueToday: 'இந்தத் தேதி இன்றுதான்.',
  datePassed: 'கவனிக்கவும்: இந்தத் தேதி ஏற்கனவே முடிந்துவிட்டது.',
  amountSentence: {
    payable: (a) => `கட்ட வேண்டிய தொகை: ${a}.`,
    income: (a) => `எழுதியுள்ள வருமானம்: ${a}.`,
    fine: (a) => `எழுதியுள்ள அபராதம் அல்லது தாமதக் கட்டணம்: ${a}.`,
    fee: (a) => `எழுதியுள்ள கட்டணம்: ${a}.`,
    sanctioned: (a) => `அனுமதிக்கப்பட்ட அல்லது அனுப்பப்பட்ட தொகை: ${a}.`,
    other: (a) => `ஒரு தொகை எழுதப்பட்டுள்ளது: ${a}.`
  },
  actionsPointer: 'காகிதம் உங்களை ஏதோ செய்யச் சொல்கிறது. கீழே "நீங்கள் செய்ய வேண்டியது" என்பதைப் பாருங்கள்.',
  noActionFound: 'காகிதம் உங்களை எதுவும் செய்யச் சொல்வதாகத் தெளிவாக இல்லை.',
  keepSafe: 'இந்தக் காகிதத்தைப் பத்திரமாக வைத்துக்கொள்ளுங்கள்.',
  doBefore: (d) => `இதை ${d} தேதிக்கு முன் செய்யுங்கள்.`,
  bringDocs: (list) => `இந்தக் காகிதங்களைத் தயாராக வைத்துக்கொள்ளுங்கள்: ${list}.`,
  contactFor: (c) => `கேள்வி இருந்தால் இங்கே கேளுங்கள்: ${c}.`,
  warningPointer: 'காகிதத்தில் ஒரு எச்சரிக்கை உள்ளது. அதைக் கவனமாகப் படியுங்கள்.',
  rejectedNext: 'இது தவறு என்று நினைத்தால், இந்தக் கடிதத்தை அனுப்பிய அலுவலகத்தில் கேளுங்கள்.',
  lowQuality: 'போட்டோ அவ்வளவு தெளிவாக இல்லை. அதனால் சில விவரங்கள் தவறாகப் படிக்கப்பட்டிருக்கலாம். அசல் காகிதத்துடன் சரிபாருங்கள்.',

  cardTodo: 'நீங்கள் செய்ய வேண்டியது',
  cardDates: 'முக்கியமான தேதிகள்',
  cardAmount: 'தொகை',
  cardWhere: 'எங்கே போக வேண்டும்',
  cardWarnings: 'கவனம்',
  cardDocs: 'தேவையான காகிதங்கள்',
  cardPerson: 'யாரைப் பற்றி',
  cardFrom: 'அனுப்பியவர்',
  cardNumbers: 'முக்கியமான எண்கள்',
  cardContact: 'தொடர்புக்கு',
  refKinds: {
    application: 'விண்ணப்ப எண்',
    certificate: 'சான்றிதழ் எண்',
    consumer: 'நுகர்வோர் எண்',
    account: 'கணக்கு எண்',
    case: 'வழக்கு எண்',
    reference: 'கடித எண்',
    registration: 'பதிவு எண்',
    receipt: 'ரசீது எண்',
    other: 'எண்'
  },
  requiredDocNames: {
    aadhaar: 'ஆதார் கார்டு',
    pan: 'பான் கார்டு',
    ration_card: 'ரேஷன் கார்டு',
    voter_id: 'வோட்டர் ஐடி',
    passbook: 'வங்கி பாஸ்புக்',
    photo: 'போட்டோ',
    income_certificate: 'வருமானச் சான்றிதழ்',
    caste_certificate: 'சாதிச் சான்றிதழ்',
    domicile_certificate: 'இருப்பிடச் சான்றிதழ்',
    birth_certificate: 'பிறப்புச் சான்றிதழ்',
    land_record: 'நிலப் பதிவு',
    electricity_bill: 'கரண்ட் பில்',
    address_proof: 'முகவரிச் சான்று',
    id_proof: 'அடையாளச் சான்று',
    affidavit: 'உறுதிமொழிப் பத்திரம் (அஃபிடவிட்)',
    application_form: 'விண்ணப்பப் படிவம்'
  },

  voiceDownloadNote: 'முதல் முறை குரல் பதிவிறக்கம் ஆகிறது (சுமார் 58 MB). அதன் பிறகு இணையம் இல்லாமலும் வேலை செய்யும்.',

  listen: 'கேளுங்கள்',
  pause: 'இடைநிறுத்துங்கள்',
  resume: 'தொடருங்கள்',
  stop: 'நிறுத்துங்கள்',
  noVoice: 'இந்த போனில் தமிழ்க் குரல் இல்லை.',
  noVoiceHint: 'போன் செட்டிங்ஸில் (Text-to-speech) குரலைச் சேர்க்கலாம், அல்லது வேறு மொழியில் கேட்கலாம்.',
  listenInHindi: 'இந்தியில் கேளுங்கள்',
  listenInEnglish: 'ஆங்கிலத்தில் கேளுங்கள்',
  noSpeechSupport: 'இந்த பிரவுசரால் சத்தமாகப் படிக்க முடியாது.',

  disclaimer: 'சம்ஜோ உங்கள் காகிதத்தை எளிமையாக விளக்குகிறது. முக்கியமான விவரங்களை எப்போதும் அசல் காகிதத்துடனோ, அதைக் கொடுத்த அலுவலகத்துடனோ சரிபாருங்கள். சம்ஜோ அரசு சேவை அல்ல. இது சட்ட ஆலோசனையும் அல்ல.',
  fullText: 'சம்ஜோ படித்தது',
  fullTextHint: 'வண்ணமிட்ட வரிகள் தெளிவாகப் படிக்கப்படவில்லை.',
  newDocument: 'புதிய காகிதம்',
  save: 'இந்த போனில் சேமியுங்கள்',
  saved: 'இந்த போனில் சேமிக்கப்பட்டது',
  share: 'பகிருங்கள்',
  copied: 'காப்பி ஆனது',
  translateLines: 'காகிதத்தின் ஆங்கில வரிகளைத் தமிழில் காட்டுங்கள்',
  helperMode: 'உதவியாளர் முறை',
  helperModeHint: 'மற்றவர்களுக்குக் காகிதங்களைப் படித்துச் சொல்பவர்களுக்கு (CSC, NGO, தன்னார்வலர்கள்). இதில் சேமிப்பு நிறுத்தப்படும், "அடுத்த நபர்" அழுத்தினால் எல்லாம் அழியும்.',
  nextPerson: 'அடுத்த நபர்',
  listenMode: 'கேட்கும் முறை',
  listenModeHint: 'விளக்கம் தயாரானதும் சம்ஜோ தானாகவே படித்துச் சொல்லும்.',
  settingsTitle: 'அமைப்புகள்',
  shareVoiceNote: 'குரல் செய்தியாக அனுப்பு',
  makingVoiceNote: 'குரல் செய்தி தயாராகிறது…',
  voiceNoteFailed: 'இந்த போனில் குரல் செய்தியை உருவாக்க முடியவில்லை.',
  translateOtherLines: 'காகிதத்தின் பிற மொழி வரிகளைத் தமிழில் காட்டுங்கள்',
  translateAiNote: 'ஆங்கிலத்தில் இல்லாத வரிகளை ஒரு AI சேவை (Groq) மொழிபெயர்க்கிறது.',
  translateConsent: 'மொழிபெயர்க்க, இந்த வரிகள் இன்டர்நெட் வழியாக சம்ஜோ சர்வருக்கு அனுப்பப்படும். அங்கே அவை சேமிக்கப்படாது. ஆதார், போன் போன்ற எண்கள் முதலிலேயே நீக்கப்படும்.',
  translateConfirm: 'சரி, மொழிபெயருங்கள்',
  translating: 'மொழிபெயர்க்கப்படுகிறது…',
  translateNote: 'இயந்திர மொழிபெயர்ப்பு — தவறுகள் இருக்கலாம்.',
  translateFailed: 'இப்போது மொழிபெயர்ப்பு கிடைக்கவில்லை.',
  retryRotated: 'போட்டோவைத் திருப்பி மீண்டும் படியுங்கள்',

  addToCalendar: 'காலெண்டரில் நினைவூட்டல் சேர்க்கவும்',
  askTitle: 'இந்த ஆவணம் பற்றி கேளுங்கள்',
  askHint: 'உங்கள் சொந்த வார்த்தைகளில் கேளுங்கள். சம்ஜோ உங்கள் ஆவணத்திலிருந்து பதில் சொல்லும் — அதில் இல்லையென்றால், அரசு இணையதளங்களிலிருந்து மட்டும்.',
  askPlaceholder: 'உங்கள் கேள்வியை எழுதுங்கள் அல்லது பேசுங்கள்…',
  askSend: 'கேள்',
  askMic: 'பேசிக் கேளுங்கள்',
  askListening: 'கேட்கிறது… இப்போது பேசுங்கள்',
  askWebToggle: 'தேவைப்பட்டால் அரசு இணையதளங்களையும் பார்க்கவும்',
  askConsent: 'பதில் சொல்ல, இந்த ஆவணத்தின் உரையும் உங்கள் கேள்வியும் இன்டர்நெட் வழியாக சம்ஜோ சர்வருக்கும் ஒரு AI சேவைக்கும் (Groq) அனுப்பப்படும். ஆதார், பான், போன் எண், ஈமெயில் முதலிலேயே நீக்கப்படும். எதுவும் சேமிக்கப்படாது.',
  askOfficialOnly: 'அரசு இணையதளங்கள் மட்டுமே பார்க்கப்படும், உதாரணமாக:',
  askConsentConfirm: 'சரி, கேள்',
  askThinkingDoc: 'உங்கள் ஆவணத்தைப் படிக்கிறது',
  askThinkingWeb: 'அரசு இணையதளங்களைப் பார்க்கிறது',
  askFromDoc: 'உங்கள் ஆவணத்திலிருந்து',
  askFromWeb: 'அரசு இணையதளத்திலிருந்து',
  askNotFound: 'இது உங்கள் ஆவணத்திலும் அரசு இணையதளங்களிலும் சம்ஜோவுக்கு கிடைக்கவில்லை. இந்த ஆவணத்தை அனுப்பிய அலுவலகத்திடம் கேளுங்கள்.',
  askUnverified: 'இதை ஆவணத்தின் சரியான வரியுடன் சம்ஜோவால் பொருத்த முடியவில்லை. ஆவணத்தைப் பார்த்து சரிபார்க்கவும்.',
  askSources: 'ஆதாரங்கள்',
  askOfficial: 'அரசு',
  askFailed: 'இப்போது பதில் கிடைக்கவில்லை. மீண்டும் முயற்சிக்கவும்.',
  askBusy: 'இப்போது நிறைய கேள்விகள் வருகின்றன. ஒரு நிமிடம் கழித்து மீண்டும் கேளுங்கள்.',
  askAiNote: 'இந்தப் பதில்களை AI எழுதியது, தவறுகள் இருக்கலாம். முக்கியமானவற்றை அலுவலகத்தில் உறுதி செய்யுங்கள்.',
  askTryNext: 'இதையும் கேட்கலாம்:',
  askJump: 'கேள்வி கேளுங்கள்',
  askSuggest: {
    fillForm: 'இந்தப் படிவத்தை எப்படி நிரப்புவது? ஒவ்வொரு கட்டத்தையும் விளக்குங்கள்.',
    first: 'நான் முதலில் என்ன செய்ய வேண்டும்?',
    deadline: 'கடைசி தேதி தவறினால் என்ன ஆகும்?',
    pay: 'இதை எப்படி, எங்கே செலுத்துவது?',
    papers: 'இந்த ஆவணங்களை எங்கே பெறுவது?',
    rejected: 'இது ஏன் நிராகரிக்கப்பட்டது, இப்போது நான் என்ன செய்யலாம்?',
    meaning: 'இந்த ஆவணத்தை மிக எளிய வார்த்தைகளில் விளக்குங்கள்.',
    contact: 'இது பற்றி யாரைத் தொடர்பு கொள்வது?',
    schemes: 'இந்த ஆவணத்தின்படி நான் எந்த அரசு திட்டங்களுக்குத் தகுதி பெறலாம்?'
  },

  helpTitle: 'உதவி பெறுங்கள்',
  nearbyTitle: 'அருகிலுள்ள அலுவலகம்',
  nearbyNote: 'உங்கள் அருகிலுள்ள வரைபடம் திறக்கும். உங்கள் இருப்பிடம் வரைபடத்துக்கு மட்டுமே போகும் — சம்ஜோ அதைப் பார்ப்பதும் இல்லை, சேமிப்பதும் இல்லை.',
  locating: 'உங்கள் இருப்பிடத்தைத் தேடுகிறது…',
  schemesTitle: 'அரசு திட்டங்கள்',
  schemesText: 'இந்த ஆவணத்தின்படி எந்தத் திட்டங்கள் உங்களுக்குப் பொருந்தலாம் என்று சம்ஜோ அரசு திட்ட இணையதளங்களில் பார்க்கலாம்.',
  schemesButton: 'எனக்கான திட்டங்களைத் தேடு',
  legalTitle: 'இலவச சட்ட உதவி',
  legalText: 'சட்டப் பணிகள் ஆணையத்திடமிருந்து உங்களுக்கு இலவச வழக்கறிஞர் கிடைக்கலாம் — உதாரணமாக பெண்கள், குழந்தைகள், SC/ST, தொழிலாளர்கள், மாற்றுத்திறனாளிகள், குறைந்த வருமானம் உள்ளவர்கள்.',
  legalCall: (n) => `${n} அழைக்கவும் (இலவசம்)`,
  legalNearby: 'அருகிலுள்ள சட்டப் பணிகள் ஆணையம்',
  legalMore: 'மேலும் சட்ட உதவி',
  legalAskConsent: 'உங்கள் கேள்வி இன்டர்நெட் வழியாக சம்ஜோ சர்வருக்கும் ஒரு AI சேவைக்கும் (Groq) அனுப்பப்படும்; அவை பதிலை அரசு இணையதளங்களில் மட்டுமே தேடும். ஆதார், பான், போன் எண், ஈமெயில் முதலிலேயே நீக்கப்படும். எதுவும் சேமிக்கப்படாது.',
  navLegal: 'சட்ட உதவி'
}
